import { Component, Inject } from "@angular/core";
import { UserState } from "../../app/store/reducers/user.reducer";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ENV_VARS } from "../../app/environment-variables/environment-variables.module";
import { OnDestroy } from "@angular/core/src/metadata/lifecycle_hooks";
import { Subscription } from "rxjs/Subscription";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import { interceptorSkipHeader } from "../../app/services/auth.interceptor";
import { AuthService } from "../../app/services/auth.service";
import { map } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { base64StringToBlob } from "blob-util";
import { _i18n_str } from "../../assets/i18n/non-static-ids";
import { TranslateService } from "@ngx-translate/core";

interface GetExtractResult {
  b64File: string;
  contentType: string;
  filename: string;
}

interface DataExtractInfo {
  "@id": string;
  title: string;
  description: string;
  study_name: string;
  data_extract_uuid: string;
  data_date: string;
  created: string;
  data_file: {
    "content-type": string;
    download: string;
    filename: string;
  };
}

interface DataExtractSearchResult {
  "@id": string;
  batching: {
    "@id": string;
    first: string;
    last: string;
    next: string;
  };
  items: DataExtractInfo[];
  items_total: number;
}

export interface NamedFile {
  download: string; // download path
  filename: string;
  "content-type": string;
}

@Component({
  selector: "data-extract-page",
  templateUrl: "data-extract.page.html"
})
export class DataExtractPage implements OnDestroy {
  userState: UserState;
  baseUrl: URL;
  storeSub: Subscription;
  dataExtracts = [];
  localizedTableMessages: {[key: string]: string};
  constructor(
    public http: HttpClient,
    public store: Store<AppState>,
    public auth: AuthService,
    public translate: TranslateService,
    @Inject(ENV_VARS) public envVars
  ) {
    this.baseUrl = new URL(envVars.API_URL + "fhirdatabase/");
    this.storeSub = this.store
      .select(state => state.user)
      .subscribe(user => {
        this.userState = user;
        this.getDataExtracts();
      });
    this.localizedTableMessages = {
      // Message to show when array is presented
      // but contains no values
      emptyMessage: translate.instant(
        _i18n_str("DATA_EXTRACT_LISTING.MESSAGES.NO_DATA_TO_DISPLAY")
      ),
      // Footer total message
      totalMessage: translate.instant(
        _i18n_str("DATA_EXTRACT_LISTING.MESSAGES.TOTAL")
      )
    };
  }

  getDataExtracts() {
    const url = `${this.baseUrl}${this.userState.organizationUuid}/@search?portal_type=DataExtract&fullobjects=1`;
    return this.http.get<DataExtractSearchResult>(url).subscribe(result => {
      console.log(result);
      this.dataExtracts = result.items || [];
    });
  }

  ngOnDestroy() {
    this.storeSub.unsubscribe();
  }

  handleExtractDownload(extract: DataExtractInfo) {
    this.http
      .get<GetExtractResult>(`${extract["@id"]}/@datafiledownload`)
      .subscribe(
        result => {
          this.saveDownloaded(result);
        },
        error => {
          console.log(JSON.stringify(error));
        }
      );
  }
  saveDownloaded(props: GetExtractResult) {
    const a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(
      base64StringToBlob(props.b64File, props.contentType)
    );
    a.download = props.filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

}



// WEBPACK FOOTER //
// ./src/pages/data-extract.page/data-extract.page.ts